import React, { FormEvent, useEffect, useState } from "react";
import { Form, Overlay, OverlayTrigger, Popover, Spinner, Tooltip } from "react-bootstrap";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import {
  EvidencePeriodData,
  ReactSelectOption,
  Student,
  StudentInfo,
} from "../../../../../../store/onboarding/types";
import { ApplicationState } from "../../../../../../store";
import CreatableSelect from "react-select/creatable";
import {
  addStudents,
  addStudentsToDataPeriod,
  addStudentToParentRequest,
  clearAddStudentsError,
  getStudents,
  openUploadStudentsRosterModal,
} from "../../../../../../store/onboarding/actions";
import Select from "react-select";
import { ValueType } from "react-select/src/types";
import { toastr } from "react-redux-toastr";
import { Placement } from "react-bootstrap/Overlay";
import {
  InterventionGroup,
  InterventionGroupPatchRequest,
} from "../../../../../../store/onboarding/cases/types";
import { patchInterventionGroup } from "../../../../../../store/onboarding/cases/actions";
import { UserInfo } from "../../../../../../store/auth/types";
import { escapeSpecialCharacter, getFullName, allowAlphaNumbers } from "../../../../../../utils/NamesUtils";
import useUserRole from "../../../../../../utils/hooks/useUserRole";
import DropdownOptionMenuList from "./DropdownOptionMenuList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChalkboardTeacher } from "@fortawesome/free-solid-svg-icons";

type PropsFromState = {
  evidencePeriodData?: EvidencePeriodData;
  interventionGroup?: InterventionGroup;
  studentsRoster: StudentInfo[];
  isLoading: {
    getStudents: boolean;
    addStudents: boolean;
    addStudentsToDataPeriod: boolean;
    patchInterventionGroup: boolean;
    addStudentToParent?: boolean;
  };
  errors: {
    getStudents?: string;
    addStudents?: string | Array<any>;
    addStudentsToDataPeriod?: string;
  };
};

type DispatchProps = {
  getStudents: (includeClasses?: boolean) => any;
  addStudents: (
    students: Array<Student>,
    addStudentsToEvidence?: boolean
  ) => any;
  addStudentsToDataPeriod: (studentsIds: number[]) => any;
  openUploadStudentsRosterModal: () => any;
  patchInterventionGroup: (
    groupId: number,
    request: InterventionGroupPatchRequest
  ) => any;
  addStudentToParent: (children: number[], parentId: number) => any;
  clearAddStudentsError: () =>  any;
};

type OwnProps = {
  placement?: Placement;
  selectedParent?: UserInfo;
  forStudentGroup?: boolean;
  showOverlay: boolean;
  buttonRef: React.MutableRefObject<any>;
  onHide: () => any;
  isNewStudent?: boolean;
 // isExistingStudent?: boolean;
};

type Props = PropsFromState & DispatchProps & OwnProps;

enum Content {
  SelectStudent,
  NewStudent,
  Children,
}

const AddStudentsToTableOverlay = (props: Props) => {
  const [content, setContent] = useState<Content>(Content.SelectStudent);
  const [studentOptions, setStudentOptions] = useState<
    ReactSelectOption<StudentInfo>[]
  >();
  const [selectedStudent, setSelectedStudent] = useState<StudentInfo[]>([]);
  const [selectedChildren, setSelectedChildren] = useState<
    ReactSelectOption<StudentInfo>[]
  >([]);
  const [studentsRoster, setStudentRoster] = useState<StudentInfo[]>([]);
  const [newStudent, setNewStudent] = useState<Student>({
    first_name: "",
    last_name: "",
    unique_id: "",
  });

  const { isDistrictOwner, isTeacher } =  useUserRole();

  useEffect(() => {
    if (props.showOverlay) {
      if (!(props.studentsRoster.length || props.isLoading.getStudents)) {
        props.getStudents();
      }
      if (props.isNewStudent) {
        setContent(Content.NewStudent);
      } else if (props.selectedParent) {
        if (props.selectedParent.children) {
          setSelectedChildren(
            props.selectedParent.children.map((student) => {
              return { label: getFullName(student), value: student };
            })
          );
        } else {
          setSelectedChildren([]);
        }

        setContent(Content.Children);
      } else {
        setContent(Content.SelectStudent);
        setSelectedStudent([]);
      }
    }
  }, [props.showOverlay]);

  useEffect(() => {
    if (props.forStudentGroup && props.interventionGroup) {
      setStudentRoster(
        props.studentsRoster.filter(
          (student) =>
            !props.interventionGroup!.students.some((s) => s.id === student.id)
        )
      );
    } else {
      setStudentRoster(
        props.evidencePeriodData
          ? props.studentsRoster.filter(
              (student) =>
                !props.evidencePeriodData!.student_rows.some(
                  (studentRow) => studentRow.student.id === student.id
                )
            )
          : props.studentsRoster
      );
    }
  }, [
    props.evidencePeriodData,
    props.studentsRoster,
    props.forStudentGroup,
    props.selectedParent,
  ]);

  useEffect(() => {
    //if (props.showOverlay) {
      setStudentOptions(
        studentsRoster.map((st) => ({
          label: st.first_name + " " + st.last_name,
          value: st,
        }))
      );
    //}
  }, [studentsRoster]);

  useEffect(() => {
    if (props.showOverlay) {
      if (!props.errors.addStudentsToDataPeriod) {
        props.onHide();
      }
    }
  }, [props.isLoading.addStudentsToDataPeriod]);

  useEffect(() => {
    if (props.showOverlay && props.forStudentGroup) {
      if (props.errors.addStudents && !Array.isArray(props.errors.addStudents)) {
        toastr.error("Failed", props.errors.addStudents!);
      }
      // Clear the error from the Redux store
      props.clearAddStudentsError?.();
    }
  }, [props.errors.addStudents]);

  const handleSelectStudent = (
    option: ValueType<ReactSelectOption<StudentInfo>, any>
  ) => {
    if (props.selectedParent) {
      setSelectedChildren((option as ReactSelectOption<StudentInfo>[]) ?? []);
    } else {
      setSelectedStudent(
        ((option as ReactSelectOption<StudentInfo>[]) ?? []).map(opt => opt.value)
      );
    }
  };

  const handleCreateStudent = (input: string) => {
    setContent(Content.NewStudent);
    const splitInput = input.split(" ");
    setNewStudent({
      first_name: splitInput[0],
      last_name: splitInput[1] || "",
      unique_id: splitInput[2] || "",
    });
  };

  const handleChange = (event: FormEvent<any>) => {
    const target = event.target as HTMLInputElement;
    let sanitizedValue = target.value;
    
      // Restrict first/last name fields
        if ( target.name === "first_name" || target.name === "last_name") {
          sanitizedValue = escapeSpecialCharacter(target.value);
        }
    
      // Restrict student ID field
        if (target.name === "unique_id") {
          sanitizedValue = allowAlphaNumbers(target.value);
        }
    setNewStudent((prevStudent) => ({
      ...prevStudent,
      [target.name]: sanitizedValue,
    }));
  };

  const handleAddStudent = () => {
    if(selectedStudent.length === 0 && selectedChildren.length === 0) {
      toastr.error("Alert", "Please select a student before continuing.");
      return;
    }
    if (props.selectedParent && selectedChildren) {
      props.addStudentToParent(
        selectedChildren.map((sc) => sc.value.id!),
        props.selectedParent.id
      );
    } else if (
      props.forStudentGroup &&
      props.interventionGroup &&
      selectedStudent
    ) {
      props
        .patchInterventionGroup(props.interventionGroup.id!, {
          students: [...props.interventionGroup.students, ...selectedStudent]
            .filter((s) => s.id != null)
            .map((s) => s.id!),
        })
        .then(() => {
          toastr.success("Success", "Student added successfully! You can find the student in the ‘Current Students’ section of this group workspace.");
          props.onHide()
        });
    } else {
      if (selectedStudent && selectedStudent.length > 0) {
        props.addStudentsToDataPeriod(selectedStudent.map(s => s.id!));
      }
    }
  };

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    props.addStudents([newStudent], props.forStudentGroup ? false : true)
      .then((responseData: any) => {
        const existingStudents: Array<number> = responseData.existing_students.map((id:string) => Number(id)) || [];
        const newStudents: Array<number> = responseData.new_students.map((id:string) => Number(id)) || [];
        const studentIds: Array<number> = (responseData.student_ids || [])?.map((id:string) => Number(id)) || [];
        
        if(existingStudents.length > 0 && newStudents.length === 0) {
          toastr.error("Failed", 
            `This Student ID already exists in this district.`
          );
        } else if (
          props.forStudentGroup &&
          props.interventionGroup &&
          studentIds
        ) {
            props
              .patchInterventionGroup(props.interventionGroup.id!, {
                students: [...props.interventionGroup.students .filter((s) => s.id != null)
                  .map((s) => s.id!), ...studentIds]
              })
              .then(() => {
                toastr.success("Success", 
                  `Student added successfully! The student has been added to the district and can be found 
                  in the ‘Current Students’ section of this group's workspace.`
                );
                props.onHide();
              });
          }
      });
  };

  const handleUploadStudentRoster = () => {
    props.openUploadStudentsRosterModal();
    props.onHide();
  };

  const formatOptionLabel = (
    option: { label: string; value: StudentInfo },
    labelMeta?: any
  ) => {
    const student = option.value;
    return (
      <div className="d-flex align-items-center justify-content-between">
        {student.unique_id
          ? `${getFullName(student).trim()}- ${student.unique_id}`
          : option.label}
        {(!!student.classes?.length || !!student.teachers?.length) && (
            <OverlayTrigger
              container={document.body}
              placement="top"
              overlay={
                <Tooltip id="fullName" className="customInfoTooltip text-left">
                  <>
                    <strong>Teachers: </strong>
                    {student.teachers
                      ?.map((teacher) => getFullName(teacher))
                      .join(", ") || <i>None</i>}
                    <br />
                  </>
                  {/* <>
                    <strong>Classes: </strong>
                    {student.classes?.map((c: any) => c.name).join(", ") || (
                      <i>None</i>
                    )}
                  </> */}
                </Tooltip>
              }
            >
              <FontAwesomeIcon className="ml-1" icon={faChalkboardTeacher} />
            </OverlayTrigger>
          )}
      </div>
    );
  };

  const filterSelectOption = (option: any, query: string) => {
    const input = query.toLowerCase();
    const label = option.label?.toLowerCase() ?? "";
    const id = option.data?.value?.unique_id?.toString().toLowerCase() ?? "";
    return label.includes(input) || id.includes(input);
  };

  const filterOption = (option: any, query: string) => {
    const input = query.toLowerCase();
    const label = option.label?.toLowerCase() ?? "";
    const id = option.value?.unique_id?.toString().toLowerCase() ?? "";
    return label.includes(input) || id.includes(input);
  };

  const isValidNewOption = (
    inputValue: string,
    _selectValue: any,
    selectOptions: readonly any[]
  ) => {
    if (props.isLoading.getStudents) return false;

    const input = inputValue.trim().toLowerCase();
    if (!input) return false;

    return !selectOptions.some(opt => {
      const labelMatch = opt.label?.toLowerCase().includes(input);
      const idMatch = opt.value?.unique_id
        ?.toString()
        .toLowerCase()
        .includes(input);

      return labelMatch || idMatch;
    });
  };

  const [searchText, setSearchText] = useState("");

  // Modified sorting logic: When searching by ID, show exact matches at the top
  const getSortedOptions = (options: { label: string, value: StudentInfo }[], input: string) => {
    if (!input) return options;

    const query = input.toLowerCase().trim();
    const isNumeric = /^\d+$/.test(query);

    return [...options].sort((a, b) => {
      if (isNumeric) {
        const aId = a.value?.unique_id?.toString().toLowerCase() || "";
        const bId = b.value?.unique_id?.toString().toLowerCase() || "";

        // Exact match comes first
        if (aId === query && bId !== query) return -1;
        if (bId === query && aId !== query) return 1;

        // Starts with query comes next
        const aStarts = aId.startsWith(query);
        const bStarts = bId.startsWith(query);
        if (aStarts && !bStarts) return -1;
        if (!aStarts && bStarts) return 1;

        // Contains query comes after
        const aIndex = aId.indexOf(query);
        const bIndex = bId.indexOf(query);
        if (aIndex !== bIndex) return aIndex - bIndex;

        // Fallback to name
        return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
      } else {
        const aName = a.label.toLowerCase();
        const bName = b.label.toLowerCase();

        // Name starts with query comes first
        const aNameStarts = aName.startsWith(query);
        const bNameStarts = bName.startsWith(query);
        if (aNameStarts && !bNameStarts) return -1;
        if (!aNameStarts && bNameStarts) return 1;

        // Name contains query comes next
        const aNameIndex = aName.indexOf(query);
        const bNameIndex = bName.indexOf(query);
        if (aNameIndex !== bNameIndex) return aNameIndex - bNameIndex;

        // Fallback to ID
        const aId = a.value?.unique_id?.toString().toLowerCase() || "";
        const bId = b.value?.unique_id?.toString().toLowerCase() || "";
        return aId.localeCompare(bId);
      }
    });
  };

  const getPopover = () => {
    switch (content) {
      case Content.SelectStudent:
        return (
          <Popover id="selectStudentsPopover" style={{ minWidth: "320px" }}>
            <Popover.Title>
              Select existing student(s) to include them in the {props.forStudentGroup ? "group" : "table"}.
            </Popover.Title>
            <Popover.Content>
              {isTeacher
                ?
                  <Select
                    isMulti
                    components={{ MenuList: DropdownOptionMenuList }}
                    value={selectedStudent.map(st => ({ label: getFullName(st), value: st }))}
                    onChange={handleSelectStudent}
                    placeholder="Search Students..."
                    getOptionLabel={(option: ReactSelectOption<StudentInfo>) => getFullName(option.value)}
                    getOptionValue={(option: ReactSelectOption<StudentInfo>) => option.value.id!.toString()}
                    options={getSortedOptions(studentOptions!, searchText)}
                    isLoading={props.isLoading.getStudents}
                    filterOption={filterSelectOption}
                    isValidNewOption={isValidNewOption}
                    formatOptionLabel={formatOptionLabel}
                    onInputChange={(value) => setSearchText(value)}
                  /> 
                :
                  <CreatableSelect
                    isMulti
                    value={selectedStudent.map(st => ({ label: getFullName(st), value: st }))}
                    onChange={handleSelectStudent}
                    onCreateOption={handleCreateStudent}
                    placeholder="Search Students..."
                    formatCreateLabel={(input: string) =>
                      `Add new student '${input}'`
                    }
                    components={{ MenuList: DropdownOptionMenuList }}
                    options={getSortedOptions(studentOptions!, searchText)}
                    isLoading={props.isLoading.getStudents}
                    allowCreateWhileLoading={false}
                    filterOption={filterOption}
                    isValidNewOption={isValidNewOption}
                    formatOptionLabel={formatOptionLabel}
                    onInputChange={(value) => setSearchText(value)}
                  />
                }
              <button
                className="mt-2 blueBtnSm w-100"
                disabled={!selectedStudent}
                onClick={handleAddStudent}
              >
                ADD STUDENT(S){" "}
                {(props.isLoading.addStudentsToDataPeriod ||
                  (props.forStudentGroup &&
                    props.isLoading.patchInterventionGroup)) && (
                  <Spinner animation="border" size="sm" />
                )}
              </button>
              {//!props.isExistingStudent && 
              !props.forStudentGroup && !isTeacher ?
              <>
                <div className="text-center font-weight-bold">OR</div>
                <button
                  className="blueBtnSm w-100"
                  onClick={handleUploadStudentRoster}
                >
                  UPLOAD A STUDENT ROSTER
                </button>
              </>
              : ''
              }
             
            </Popover.Content>
          </Popover>
        );
      case Content.Children:
        return (
          <Popover id="selectStudentsPopover"  style={{ minWidth: "320px" }}>
            <Popover.Title>Select existing student(s) to include them in the {props.forStudentGroup ? "group" : "table"}.</Popover.Title>
            <Popover.Content>
               {isTeacher
                ?
                  <Select
                    isMulti
                    components={{ MenuList: DropdownOptionMenuList }}
                    onChange={handleSelectStudent}
                    placeholder="Search Students..."
                    getOptionLabel={(option: ReactSelectOption<StudentInfo>) => getFullName(option.value)}
                    getOptionValue={(option: ReactSelectOption<StudentInfo>) => option.value.id!.toString()}
                    options={studentOptions}
                    isLoading={props.isLoading.getStudents}
                  /> 
                :
                  <CreatableSelect
                    isMulti
                    components={{ MenuList: DropdownOptionMenuList }}
                    value={selectedChildren}
                    createOptionPosition="first"
                    onChange={handleSelectStudent}
                    onCreateOption={handleCreateStudent}
                    placeholder="Search Students..."
                    formatCreateLabel={(input: string) =>
                      `Add new student '${input}'`
                    }
                    allowCreateWhileLoading
                    options={studentOptions}
                    isLoading={props.isLoading.getStudents}
                  />
                }
              <button
                className="mt-2 blueBtnSm w-100"
                onClick={handleAddStudent}
                disabled={selectedChildren.length === 0 || selectedStudent === undefined || props.isLoading.addStudentToParent}
              >
                {props.selectedParent?.children?.length ? "UPDATE" : "ADD"}
                &nbsp;STUDENT(S)
                {props.isLoading.addStudentToParent && (
                  <Spinner animation="border" size="sm" className={"ml-1"} />
                )}
              </button>
            </Popover.Content>
          </Popover>
        );
      case Content.NewStudent:
        return (
          <Popover id="addStudentsPopover" style={{ minWidth: "320px" }}>
            <Popover.Title>Add a new student to the district and include them in the {props.forStudentGroup ? "group" : "table"}.</Popover.Title>
            <Popover.Content>
              <Form onSubmit={handleSubmit}>
                <Form.Group>
                  <Form.Label column={false} className="font-weight-bold text-left">
                    First Name
                  </Form.Label><span className="label-asterisk">*</span>
                  <Form.Control
                    required
                    placeholder="Enter"
                    name="first_name"
                    onChange={handleChange}
                    value={newStudent.first_name}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label column={false} className="font-weight-bold text-left">
                    Last Name
                  </Form.Label><span className="label-asterisk">*</span>
                  <Form.Control
                    required
                    placeholder="Enter"
                    name="last_name"
                    onChange={handleChange}
                    value={newStudent.last_name}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label column={false} className="font-weight-bold text-left">
                    Student ID
                  </Form.Label><span className="label-asterisk">*</span>
                  <Form.Control
                    required
                    placeholder="Enter"
                    name="unique_id"
                    onChange={handleChange}
                    value={newStudent.unique_id}
                  />
                </Form.Group>
                <button 
                className="blueBtnSm w-100" 
                type="submit"
                disabled={
                  !newStudent.first_name ||
                  !newStudent.last_name ||
                  !newStudent.unique_id ||
                  props.isLoading.addStudents
                }>
                  ADD STUDENT{" "}
                  {(props.isLoading.addStudents ||
                    props.isLoading.addStudentsToDataPeriod) && (
                    <Spinner animation="border" size="sm" />
                  )}
                </button>
                {/* <hr />
                <button
                  className="blueBtnSm w-100"
                  onClick={handleUploadStudentRoster}
                >
                  UPLOAD A STUDENT ROSTER
                </button> */}
              </Form>
            </Popover.Content>
          </Popover>
        );
    }
  };

  return (
    <Overlay
      target={props.buttonRef && props.buttonRef.current}
      show={props.showOverlay}
      placement={props.placement || "top"}
      rootClose
      rootCloseEvent={"click"}
      onHide={props.onHide}
      flip
    >
      {getPopover()}
    </Overlay>
  );
};

const mapStateToProps = ({
  onboarding,
  cases,
}: ApplicationState): PropsFromState => {
  return {
    errors: {
      getStudents: onboarding.errors.getStudents,
      addStudents: onboarding.errors.addStudents,
      addStudentsToDataPeriod: onboarding.errors.addStudentsToDataPeriod,
    },
    isLoading: {
      getStudents: onboarding.isLoading.getStudents,
      addStudents: onboarding.isLoading.addStudents,
      addStudentsToDataPeriod: onboarding.isLoading.addStudentsToDataPeriod,
      patchInterventionGroup: cases.isLoading.patchInterventionGroup,
      addStudentToParent: onboarding.isLoading.addStudentToParent,
    },
    evidencePeriodData: onboarding.evidencePeriodData,
    studentsRoster: onboarding.studentsRoster,
    interventionGroup: cases.selectedInterventionGroup,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      getStudents: getStudents,
      addStudents: addStudents,
      addStudentsToDataPeriod: addStudentsToDataPeriod,
      openUploadStudentsRosterModal: openUploadStudentsRosterModal,
      patchInterventionGroup: patchInterventionGroup,
      addStudentToParent: addStudentToParentRequest,
      clearAddStudentsError: clearAddStudentsError,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddStudentsToTableOverlay);
